import React from "react";
import HOC from "../../../components/HOC";
import ListRequestWarehouse from "../../../components/screen/centralWarehouse/request/ListRequestWarehouse";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const RequestTransferListPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Request Transfer"
        mainComponent={
          <ThemeProvider theme={theme}>
            <ListRequestWarehouse type={5} />
          </ThemeProvider>
        }
        pageRole={38}
      />
    </div>
  );
};

export default HOC(RequestTransferListPage);
